// extracted by mini-css-extract-plugin
module.exports = {"stake":"stake_stake__hB0LM","footer":"stake_footer__d_A8L"};